import { FC } from 'react'
import { classNames } from '@/utils'

type Props = {
  title: string
  solutions: Solution[]
  url: string
  imageSize: string
  isImageRight?: boolean
}

type Solution = {
  subTitle: string
  details: string
  attention?: string
}

const Component: FC<Props> = ({ title, solutions,  url, isImageRight }) => {
  return (
    <div className={
      classNames(
        'flex flex-col gap-4',
        isImageRight
          ? 'lg:flex-row-reverse'
          : 'lg:flex-row'
      )}>
      <img className="max-w-[500px]" src={url} alt={title} />
      <div className="flex flex-col gap-4 lg:gap-9">
        <h3 className="text-xl font-semibold text-primary-800">{title}</h3>
        {solutions.map((s) => {
          return (
            <div className="flex flex-col gap-2 lg:gap-4" key={s.subTitle}>
              <h4 className="text-lg text-secondary-700 font-medium">{s.subTitle}</h4>
              <p>{s.details}</p>
              {s.attention ? <p className="text-xs text-gray-600">{s.attention}</p> : <></>}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Component
